function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var x = Object.defineProperty,
    y = Object.defineProperties;
var N = Object.getOwnPropertyDescriptors;
var c = Object.getOwnPropertySymbols;
var v = Object.prototype.hasOwnProperty,
    f = Object.prototype.propertyIsEnumerable;

var b = function b(e, s, n) {
  return s in e ? x(e, s, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: n
  }) : e[s] = n;
},
    r = function r(e, s) {
  for (var n in s || (s = {})) {
    v.call(s, n) && b(e, n, s[n]);
  }

  if (c) {
    var _iterator = _createForOfIteratorHelper(c(s)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var n = _step.value;
        f.call(s, n) && b(e, n, s[n]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    C = function C(e, s) {
  return y(e, N(s));
};

var t = function t(e, s) {
  var n = {};

  for (var u in e) {
    v.call(e, u) && s.indexOf(u) < 0 && (n[u] = e[u]);
  }

  if (e != null && c) {
    var _iterator2 = _createForOfIteratorHelper(c(e)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var u = _step2.value;
        s.indexOf(u) < 0 && f.call(e, u) && (n[u] = e[u]);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return n;
};

import o, { useRef as R } from "react";
import { Menu as g, MenuItem as D, MenuDivider as E, SubMenu as _, ControlledMenu as k, useMenuState as B } from "@szhsin/react-menu";
import "./menu.css";
import H from "classnames";

var I = function I(e) {
  return e.map(function (P, u) {
    var a = P,
        s = a.name,
        n = t(a, ["name"]);

    if (s === "sub-menu") {
      var p = n,
          m = p.menuItems,
          M = t(p, ["menuItems"]);
      return o.createElement(_, r({
        key: u
      }, M), I(m));
    }

    if (s === "menu-item") {
      var i = n,
          _m = i.startIcon,
          _M = i.endIcon,
          l = i.children,
          d = t(i, ["startIcon", "endIcon", "children"]);
      return o.createElement(D, r({
        key: u
      }, d), _m, o.createElement("span", {
        className: "rc-menu__item__children"
      }, l), _M);
    }

    return s === "divider" ? o.createElement(E, r({
      key: u
    }, n)) : null;
  });
},
    T = function T(e) {
  var m = B(),
      s = m.openMenu,
      n = m.closeMenu,
      u = m.toggleMenu,
      P = t(m, ["openMenu", "closeMenu", "toggleMenu"]),
      a = R(null);

  if ("hover" in e) {
    var M = e,
        d = M.menuButton,
        h = M.menuItems,
        F = M.hover,
        S = t(M, ["menuButton", "menuItems", "hover"]);
    return o.createElement("div", {
      className: H("lc-menu", {
        open: P.isOpen
      }),
      onMouseLeave: n
    }, o.createElement("div", {
      className: "lc-menu-button-wrapper",
      ref: a,
      onMouseEnter: function onMouseEnter() {
        return s();
      }
    }, d), o.createElement(k, C(r(r({}, P), S), {
      anchorRef: a,
      align: "end",
      onClose: function onClose() {
        return n();
      },
      onMouseLeave: n
    }), I(h)));
  }

  var l = e,
      p = l.menuItems,
      i = t(l, ["menuItems"]);
  return o.createElement(g, r({
    className: "lc-menu",
    position: "initial"
  }, i), I(p));
};

export { T as Menu };